import { action, observable, toJS } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/shou_xie/setMeal'
import SetMealApi from '@api/setMeal'

class Store extends BaseStore {
  @observable is_shop
  @action
  getIsShop = value => {
    this.is_shop = value
  }

  $listApi = Api.getCaseSortList
  $pageSize = 999
  $getParams = () => {
    const { is_shop, merchant_category_id } = this

    if (is_shop) {
      return {
        is_shop,
        commodity_type: 1,
        merchant_category_id
      }
    } else {
      return {
        is_sold_out: 0,
        status: 1,
        commodity_type: 1,
        merchant_category_id
      }
    }
  }

  @observable length = 0
  $extraOp = data => {
    this.length = data.total_count
  }
  @action
  orderFn = (id, index, direction) => async () => {
    let orderId = ''
    if (direction == 'up') {
      orderId = toJS(this.$list)[index - 1].id
    } else if (direction == 'down') {
      orderId = toJS(this.$list)[index + 1].id
    } else {
      orderId = toJS(this.$list)[0].id
    }
    let set_meal_ids = []
    set_meal_ids.push(id, orderId)
    let params = {
      set_meal_ids: set_meal_ids.join(),
      shuijing: this.is_shop == 1 ? 1 : null
    }
    let { success } = await SetMealApi.changeOrder(params)
    if (success) {
      this.$getList()
    }
  }

  orderTop = async id => {
    let { success } = await Api.toTopApi({ id, is_top: 1 })
    if (success) {
      this.$getList()
    }
  }

  @observable categoryList = []
  merchantCategory = async () => {
    let { data } = await Api.merchantCategory()
    this.categoryList = data || []
  }

  @observable merchant_category_id = ''
  changeValue = value => {
    this.merchant_category_id = value
    this.$getList(1, { merchant_category_id: value })
  }

  reset = () => {
    this.merchant_category_id = ''
    this.$getList(1)
  }
}
export default new Store()
